import { getCurrentUser } from "../common/routines/user-operations";

export const LEAD_STATUS_OPTIONS = [
  { value: "New Lead" },
  { value: "Not Qualified" },
  { value: "Qualified" },
  { value: "Contact Attempted" },
  { value: "In Progress" },
  { value: "Converted" },
  { value: "Closed-Won" },
  { value: "Closed-Lost" },
  { value: 'Draft' },
];

export const PARTNER_LEAD_STATUS_OPTIONS = [
  { value: "Qualified" },
  { value: "Contact Attempted" },
  { value: "In Progress" },
  { value: "Converted" },
  { value: "Closed-Won" },
  { value: "Closed-Lost" },
];

export const LEAD_SOURCE_OPTIONS = [
  { value: "Advertisement" },
  { value: "Call" },
  { value: "Agent" },
  { value: "External Referral" },
  { value: "Email Query" },
  { value: "X (Twitter)" },
  { value: "Facebook" },
  { value: "Partner" },
  { value: "Public Relations" },
  { value: "Sales Email" },
  { value: "Seminar Partner" },
  { value: "Internal Seminar" },
  { value: "Web Research" },
  { value: "Chatbot" },
  { value: "Manual" },
  { value: "Horizon" },
  { value: "Website" },
];

export const INDUSTRY_OPTIONS = [{ value: "Funeral Services" }];

export const INTERESTED_PRODUCT_OPTIONS = [
  { value: "Preneed" },
  { value: "At-Need" },
  { value: "Consultation" },
  { value: "Miscellaneous" },
];

export const RATING_OPTIONS = [
  { value: "Not Interested", label: "not-interested" },
  { value: "Least Interest", label: "least-interest" },
  { value: "Low Interest", label: "low-interest" },
  { value: "Slight Interest", label: "slight-interest" },
  { value: "Mild Interest", label: "mild-interest" },
  { value: "Moderate Interest", label: "moderate-interest" },
  { value: "Interested & Engaged", label: "interested-engaged" },
  { value: "High Interest", label: "high-interest" },
  { value: "Immediate Interest", label: "immediate-interest" },
  { value: "Engage & Convert", label: "engage-convert" },
];
const leadOwnerDetails = getCurrentUser();
const leadOwner =
  leadOwnerDetails?.firstName + " " + leadOwnerDetails?.lastName;

export const LEAD_OWNER_OPTIONS = [{ value: leadOwner }];
export const MARITAL_STATUS_OPTIONS = [{ value: "Married" }, { value: "Single" }, { value: "Divorced" }, { value: "Widowed" }, { value: "Separated" }, { value: "Partnered" }, { value: "Prefer not to say" }];
export const RELATIONSHIP_OPTIONS = [
  { value: "Self" },
  { value: "Spouse" },
  { value: "Partner" },
  { value: "Father" },
  { value: "Mother" },
  { value: "Son" },
  { value: "Daughter" },
  { value: "Brother" },
  { value: "Sister" },
  { value: "Grandparent" },
  { value: "Grandchild" },
  { value: "Relative" },
  { value: "Legal Guardian" },
  { value: "Power of Attorney" },
  { value: "Aunt" },
  { value: "Uncle" },
  { value: "Niece" },
  { value: "Nephew" },
  { value: "Cousin" },
  { value: "Stepparent" },
  { value: "Stepchild" },
  { value: "Friend" },
  { value: "Other" },
  { value: "Prefer not to say" },
];

export { };
